var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Affiliate Terms of Service: ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      "Listed below are the terms and conditions associated with our affiliate program."
                    )
                  ]),
                  _c("p", [_c("b", [_c("u", [_vm._v("Payment")])])]),
                  _c("p", [
                    _vm._v(
                      "Affiliates are paid $50.00 for the first referred sale in a calendar month. During the same calendar month if an affiliate refers a second sale both the first and second sale.s commissions will increase to $60. During the same calendar month if an affiliate refers a third sale all three sale.s commissions will increase to $70. During the same calendar month if an affiliate refers a fourth sale all four sale.s commissions will increase to $80. During the same calendar month if an affiliate refers a fifth sale all five sale.s commissions will increase to $90. During the same calendar month if an affiliate refers a sixth sale all six sale.s commissions will increase to $100 as well as any additional sales brought in by that affiliate for the given calendar month. The calendar month is defined as starting on the first day of that calendar month (for instance January 1st) and ending on the last day of that calendar month (for instance January 31st). A reversal of a sale during that month will reduce the affiliate commission rate to the next lowest tier."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "All affiliate commissions are processed and sent to affiliates 35-40 days after the end of the month in which the sale occurred. You can see the affiliate payment schedule at our FAQ section under affiliate payments."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Please allow for 5-10 business days (allowing for weekends and holidays) for your payment to reach you."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "You must generate a commissionable sale worth $50 commissions to receive your first $50 Commission payout."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Commission payments are made via PayPal or Wire Transfer (only available for accounts earning $10,000 or more per pay period). To setup PayPal or Wire Transfer accounts, contact the affiliate manager using the info provided below."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates are responsible for checking with their bank to ensure they accept check payments from the US."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates are responsible for any and all fees, taxes, exchange rates, surcharges and other expenses incurred in order to receive their commissions. Please check with your local banking institution to find out if any of these apply for your area/country."
                    )
                  ]),
                  _c("p", [_c("b", [_c("u", [_vm._v("Reversals:")])])]),
                  _c("p", [
                    _vm._v(
                      "Referrals that have been issued a refund within the first 30 days of service will be deducted from commissions owed."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Referrals must have an active hosting account for 30 consecutive days or commissions will be reversed."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Referrals that are found to be fraudulent (false information, fake/stolen credit cards etc.) will be reversed."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Referrals that issue a credit card charge back will be reversed."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates may not receive commissions for web hosting accounts that they themselves purchase unless expressly approved by the Green Geeks affiliate department in writing."
                    )
                  ]),
                  _c("p", [
                    _c("b", [_c("u", [_vm._v("Advertising Compliance:")])])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates may not offer cash back, rate reducing coupons, rewards or incentives without written approval. Please contact us if you would like to have your site reviewed."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "All coupons issued by Green Geeks for affiliates advertising or for Green Geeks internal advertising take precedence over the affiliate tracking code and commissions will not be issued to affiliates for any accounts purchased which uses a coupon unless otherwise specified by Green Geeks."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Unless otherwise authorized, affiliates may not bid on trademark keywords for the purpose of PPC on the search engines (Google, Yahoo, MSN, Ask). Any affiliates found bidding on trademarked terms may be deactivated and their commissions forfeited at the discretion of the Green Geeks Affiliate program manager. For a list of banned keywords, please contact the affiliate manager using the information provided below."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates may use the approved banners and ad text code found in the affiliate management center. Affiliates are responsible for ensuring that their tracking code is working properly before sending traffic to our servers. Any modification to the links is the sole responsibility of the affiliate – commissions will not be paid for tracking errors caused by editing, masking or tampering with your links."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "All affiliates must comply with the FTC rules regarding the use of endorsements and testimonials in advertising or promoting GreenGeeks service. Please read our FAQ regarding these rules at: "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://kb.greengeeks.com/1768/federal-trade-commission-affiliate-requirements-please-read/"
                        }
                      },
                      [_vm._v("FTC Disclosure FAQ")]
                    )
                  ]),
                  _c("p", [_c("b", [_c("u", [_vm._v("Deactivation:")])])]),
                  _c("p", [
                    _vm._v(
                      "Affiliate accounts may be deactivated at any time without warning or advanced notice. Your account WILL BE DEACTIVATED and commissions set to $0 for failure to comply with the Affiliate Terms contained herein."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Any false or misleading advertising or suspected fraudulent activity associated with your affiliate account will result in immediate deactivation."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliate accounts generating a large number of fraudulent accounts may be deactivated upon review."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Affiliates may not .resell the Green Geeks web hosting service, offenders will be deactivated."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "If you would like to discontinue your affiliate status, simply remove your affiliate links and no longer promote them. For accounting purposes your account and personal information will not be completely removed from our system."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "BY REGISTERING AS AN AFFILIATE YOU ARE AGREEING TO THE TERMS AND CONDITIONS. IF YOU DO NOT AGREE TO THE TERMS AND CONDITIONS, YOU MUST DISCONTINUE THE REGISTRATION PROCESS, DISCONTINUE YOUR USE OF THE AFFILIATE PROGRAM, OR DEACTIVATE YOUR ACCOUNT IF YOU ARE ALREADY A MEMBER. "
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Changes to the Terms and Conditions apply to you. You may review the most current version of the Terms and Conditions at the site. Green Geeks may change the Terms and Conditions, in whole or in part, at any time at Green Geeks sole discretion with or without written notification. Posting of such changed Terms and Conditions on the site shall constitute notice of such changes to you, although Green Geeks may choose additional types of notification. While Green Geeks may attempt notification to our affiliates of any changes to our Terms and Conditions however, at times, notification is not possible (as in a change in email address or phone number) and therefore it is the sole responsibility of the affiliate to check back on our Affiliate Terms and Conditions page to discover any changes. Affiliates may also contact our affiliate program manager at any time to discover any changes to the affiliate Terms and Conditions. Your continued use of the Affiliate Program constitutes your acceptance of all changes to the Terms and Conditions. If you do not agree to any such changes, your sole and exclusive remedy is to deactivate your account as described above."
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }